export enum HttpStatusEnum {
    NotFound = 404,
    Accepted = 202,
    InternalServer = 500
}